<p>customer-cheque-account works!</p>
